"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInstallerInfo = void 0;
var index_1 = require("../index");
var helpers_1 = require("../helpers/helpers");
var http_1 = require("../helpers/http");
var messages_1 = require("../constants/messages");
/**
 * Get the latest Aspera SDK installer information such as download URL and version.
 *
 * @param options Installer info options
 *
 * @returns a promise that resolves with the installer info and rejects if there is an error
 */
var getInstallerInfo = function (options) {
    if (options === void 0) { options = {}; }
    var url = options.endpoint || index_1.asperaSdk.globals.installerUrl;
    if (url.endsWith('/latest.json')) {
        url = url.replace('/latest.json', '');
    }
    if (!(0, helpers_1.isValidURL)(url)) {
        return (0, helpers_1.throwError)(messages_1.messages.invalidEndpoint, { url: url });
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    (0, http_1.apiGet)("".concat(url, "/latest.json")).then(function (response) {
        response.json().then(function (data) {
            if (options.endpoint) {
                for (var _i = 0, _a = data.entries; _i < _a.length; _i++) {
                    var entry = _a[_i];
                    if (!(0, helpers_1.isValidURL)(entry.url)) {
                        entry.url = "".concat(options.endpoint, "/").concat(entry.url);
                    }
                }
            }
            if (options.all) {
                promiseInfo.resolver(data);
            }
            else {
                var platform_1 = (0, helpers_1.getCurrentPlatform)();
                data.entries = data.entries.filter(function (entry) { return entry.platform === platform_1; });
                promiseInfo.resolver(data);
            }
        });
    }).catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.getInstallerError, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.getInstallerError, error));
    });
    return promiseInfo.promise;
};
exports.getInstallerInfo = getInstallerInfo;
